import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  GLOBAL_STATE,
  PFC_APPLICATION_EDIT,
  PFC_APPLICATION_FORM_ALL,
  PFC_APPLICATION_FORM_CURRENT,
  PFC_APPLICATION_FORM_FIELD_BATCH,
  PFC_APPLICATION_LIST,
  PFC_PAYMENT_ALL,
  PFC_PAYMENT_CONFIRM,
  PFC_PAYMENT_CREATE,
  PFC_PAYMENT_LIST,
  PFC_PAYMENT_PRINCIPAL,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const PRE_FOUNDATION = GLOBAL_STATE

export const { reducer: preFoundationReducer } = createSlice({
  name: PRE_FOUNDATION,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.pfcApplicationEdit.pending, state => {
        state[PFC_APPLICATION_EDIT].loading = true
      })
      .addCase(actionCreators.pfcApplicationEdit.rejected, (state, action) => {
        state[PFC_APPLICATION_EDIT].loading = false
        state[PFC_APPLICATION_EDIT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.pfcApplicationEdit.fulfilled, (state, action) => {
        state[PFC_APPLICATION_EDIT].loading = false
        state[PFC_APPLICATION_EDIT].error = null
        state[PFC_APPLICATION_EDIT].data = action.payload
      })

    builder
      .addCase(actionCreators.pfcApplicationList.pending, state => {
        state[PFC_APPLICATION_LIST].loading = true
      })
      .addCase(actionCreators.pfcApplicationList.rejected, (state, action) => {
        state[PFC_APPLICATION_LIST].loading = false
        state[PFC_APPLICATION_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.pfcApplicationList.fulfilled, (state, action) => {
        state[PFC_APPLICATION_LIST].loading = false
        state[PFC_APPLICATION_LIST].error = null
        state[PFC_APPLICATION_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.pfcPaymentList.pending, state => {
        state[PFC_PAYMENT_LIST].loading = true
      })
      .addCase(actionCreators.pfcPaymentList.rejected, (state, action) => {
        state[PFC_PAYMENT_LIST].loading = false
        state[PFC_PAYMENT_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.pfcPaymentList.fulfilled, (state, action) => {
        state[PFC_PAYMENT_LIST].loading = false
        state[PFC_PAYMENT_LIST].error = null
        state[PFC_PAYMENT_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.pfcPaymentAll.pending, state => {
        state[PFC_PAYMENT_ALL].loading = true
      })
      .addCase(actionCreators.pfcPaymentAll.rejected, (state, action) => {
        state[PFC_PAYMENT_ALL].loading = false
        state[PFC_PAYMENT_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.pfcPaymentAll.fulfilled, (state, action) => {
        state[PFC_PAYMENT_ALL].loading = false
        state[PFC_PAYMENT_ALL].error = null
        state[PFC_PAYMENT_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.pfcPaymentPrincipal.pending, state => {
        state[PFC_PAYMENT_PRINCIPAL].loading = true
      })
      .addCase(actionCreators.pfcPaymentPrincipal.rejected, (state, action) => {
        state[PFC_PAYMENT_PRINCIPAL].loading = false
        state[PFC_PAYMENT_PRINCIPAL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.pfcPaymentPrincipal.fulfilled, (state, action) => {
        state[PFC_PAYMENT_PRINCIPAL].loading = false
        state[PFC_PAYMENT_PRINCIPAL].error = null
        state[PFC_PAYMENT_PRINCIPAL].data = action.payload
      })

    builder
      .addCase(actionCreators.pfcPaymentCreate.pending, state => {
        state[PFC_PAYMENT_CREATE].loading = true
      })
      .addCase(actionCreators.pfcPaymentCreate.rejected, (state, action) => {
        state[PFC_PAYMENT_CREATE].loading = false
        state[PFC_PAYMENT_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.pfcPaymentCreate.fulfilled, (state, action) => {
        state[PFC_PAYMENT_CREATE].loading = false
        state[PFC_PAYMENT_CREATE].error = null
        state[PFC_PAYMENT_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.pfcPaymentConfirm.pending, state => {
        state[PFC_PAYMENT_CONFIRM].loading = true
      })
      .addCase(actionCreators.pfcPaymentConfirm.rejected, (state, action) => {
        state[PFC_PAYMENT_CONFIRM].loading = false
        state[PFC_PAYMENT_CONFIRM].error = action.payload as AxiosError
      })
      .addCase(actionCreators.pfcPaymentConfirm.fulfilled, (state, action) => {
        state[PFC_PAYMENT_CONFIRM].loading = false
        state[PFC_PAYMENT_CONFIRM].error = null
        state[PFC_PAYMENT_CONFIRM].data = action.payload
      })

    builder
      .addCase(actionCreators.pfcApplicationFormAll.pending, state => {
        state[PFC_APPLICATION_FORM_ALL].loading = true
      })
      .addCase(actionCreators.pfcApplicationFormAll.rejected, (state, action) => {
        state[PFC_APPLICATION_FORM_ALL].loading = false
        state[PFC_APPLICATION_FORM_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.pfcApplicationFormAll.fulfilled, (state, action) => {
        state[PFC_APPLICATION_FORM_ALL].loading = false
        state[PFC_APPLICATION_FORM_ALL].error = null
        state[PFC_APPLICATION_FORM_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.pfcApplicationFormCurrent.pending, state => {
        state[PFC_APPLICATION_FORM_CURRENT].loading = true
      })
      .addCase(actionCreators.pfcApplicationFormCurrent.rejected, (state, action) => {
        state[PFC_APPLICATION_FORM_CURRENT].loading = false
        state[PFC_APPLICATION_FORM_CURRENT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.pfcApplicationFormCurrent.fulfilled, (state, action) => {
        state[PFC_APPLICATION_FORM_CURRENT].loading = false
        state[PFC_APPLICATION_FORM_CURRENT].error = null
        state[PFC_APPLICATION_FORM_CURRENT].data = action.payload
      })

    builder
      .addCase(actionCreators.pfcApplicationFormFieldById.pending, state => {
        state[PFC_APPLICATION_FORM_FIELD_BATCH].loading = true
      })
      .addCase(actionCreators.pfcApplicationFormFieldById.rejected, (state, action) => {
        state[PFC_APPLICATION_FORM_FIELD_BATCH].loading = false
        state[PFC_APPLICATION_FORM_FIELD_BATCH].error = action.payload as AxiosError
      })
      .addCase(actionCreators.pfcApplicationFormFieldById.fulfilled, (state, action) => {
        state[PFC_APPLICATION_FORM_FIELD_BATCH].loading = false
        state[PFC_APPLICATION_FORM_FIELD_BATCH].error = null
        state[PFC_APPLICATION_FORM_FIELD_BATCH].data = action.payload
      })

    builder.addCase(actionCreators.pfcApplicationEditClear, state => {
      state[PFC_APPLICATION_EDIT] = defaultState()
    })

    builder.addCase(actionCreators.pfcApplicationListClear, state => {
      state[PFC_APPLICATION_LIST] = defaultState()
    })

    builder.addCase(actionCreators.pfcPaymentListClear, state => {
      state[PFC_PAYMENT_LIST] = defaultState()
    })

    builder.addCase(actionCreators.pfcPaymentAllClear, state => {
      state[PFC_PAYMENT_ALL] = defaultState()
    })

    builder.addCase(actionCreators.pfcPaymentPrincipalClear, state => {
      state[PFC_PAYMENT_PRINCIPAL] = defaultState()
    })

    builder.addCase(actionCreators.pfcApplicationFormAllClear, state => {
      state[PFC_APPLICATION_FORM_ALL] = defaultState()
    })

    builder.addCase(actionCreators.pfcApplicationFormCurrentClear, state => {
      state[PFC_APPLICATION_FORM_CURRENT] = defaultState()
    })

    builder.addCase(actionCreators.pfcApplicationFormFieldByIdClear, state => {
      state[PFC_APPLICATION_FORM_FIELD_BATCH] = defaultState()
    })
  },
})
